import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import get from 'lodash/get';
import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import { isAttachmentShapeModel, isAttachmentImageElement, isDocAttachmentElement, isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { IElementBaseModel } from '../../../Interface/base/element-base-model.interface';
import { enumerateGroup } from '../enumerate';
import { IGroupModel } from '../../../Interface/group-model.interface';

/**
 * 符合以下情况的元素不能被组合
 * @param curElement 某元素
 * @returns 如果不能组合就返回true
 */
// eslint-disable-next-line complexity
export const isUnsupportGroup = (curElement: IElementBaseModel): boolean => (
    get(curElement, `props.${Locks.LOCKS}.noGrp`) === 1 // 设置了不能组合属性的元素 不能成组
    || curElement.isPlaceholder // 占位符不能成组
    || curElement.type === UIModelType.TABLE // 表格元素不能成组
    || curElement.type === UIModelType.SMART_ART // 智能图表暂时不能成组(暂关闭)
    || curElement.parent?.type === UIModelType.GROUP // 组合内的元素不能成组，应该最外面的组合元素来进行成组
    || !(curElement.parent?.type === UIModelType.SLIDE || curElement.parent?.type === UIModelType.MASTER
        || curElement.parent?.type === UIModelType.LAYOUT
    ) // 最外面的组合元素来进行成组，如果父节点slide、master、layout都不是的话就无法成组
    || isIframeShapeModel(curElement)
    || isAttachmentShapeModel(curElement)
    || isAttachmentImageElement(curElement)
    || isDocAttachmentElement(curElement)
);

/**
 * 是否可以取消组合
 */
export const canUnGroup = (selectedArray: IElementBaseModel[] | null): boolean => {
    if (!selectedArray) return false;
    for (let index = 0; index < selectedArray?.length; index++) {
        if (selectedArray[index].type === UIModelType.GROUP) {
            return true;
        }
    }
    return false;
};

/**
 * 检查多选的元素是否可组合
 * @param selectedArray 多选元素
 * @returns 如果所选中的元素中有一个不能被组合，就返回false
 */
const isElementsCanGroup = (selectedArray: IElementBaseModel[] | null): boolean => {
    const length = selectedArray?.length;
    if (!length) return false;
    for (let index = 0; index < length; index++) {
        if (isUnsupportGroup(selectedArray[index])) {
            return false;
        }
    }
    return true;
};
export default isElementsCanGroup;

export interface IRelativeProps {
    relativeRotate?: number,
    relativeFlipH?: number,
    relativeFlipV?: number,
}
/**
* 获取组合子元素相对父组合的旋转和翻转信息
* @param element 组合子元素
* @returns
*/
export const getGroupChildRelativeProps = (element: IElementBaseModel): IRelativeProps => {
    const elementStyle = element.props.style;
    const realFrameOnSlide = element.getFrame?.().frameOnSlide();
    let relativeFlipH = realFrameOnSlide.flipH;
    if (elementStyle.flipH === 1) {
        relativeFlipH = relativeFlipH === 0 ? 1 : 0;
    }
    let relativeFlipV = realFrameOnSlide.flipV;
    if (elementStyle.flipV === 1) {
        relativeFlipV = relativeFlipV === 0 ? 1 : 0;
    }
    let relativeRotate = 0;
    enumerateGroup(element, (groupModel: IGroupModel) => {
        relativeRotate = (groupModel.getFrame().getRotate() + relativeRotate) % 360;
    });
    return {
        relativeFlipH,
        relativeFlipV,
        relativeRotate,
    };
};

/**
* 返回组合子元素相对父组合的offset信息
* @param props 偏移信息
* @param x 相对slide的偏移x
* @param y 相对slide的偏移y
*/
export const getOffsetWithRelative = (
    props: IRelativeProps | null,
    x: number,
    y: number,
): { offsetX: number, offsetY: number} => {
    let offsetX = x;
    let offsetY = y;
    if (props?.relativeRotate) {    // 外层角度修正
        const { relativeRotate } = props;
        const angle = (relativeRotate % 360) * Math.PI / 180;
        const cosAngle = Math.cos(angle);
        const sinAngle = Math.sin(angle);
        const relativeX = (offsetX * cosAngle) + (offsetY * sinAngle);
        const relativeY = (offsetY * cosAngle) - (offsetX * sinAngle);
        offsetX = relativeX;
        offsetY = relativeY;
    }
    if (props?.relativeFlipH === 1) {   // 外层FlipH修正
        offsetX = -offsetX;
    }
    if (props?.relativeFlipV === 1) {   // 外层FlipV修正
        offsetY = -offsetY;
    }
    return {
        offsetX,
        offsetY,
    };
};
